import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { I18n, Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { Panel as CommonPanel } from '../../../common/panel'
import { panelTypes } from '../../../common/panel/constants'
import { SCREEN } from '../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../common/selectCurrencyUnit/useFormatCurrency'
import { SelectCustom } from '../../../common/selectCustom'
import {
  selectComponentAuthorized,
  selectUserType,
} from '../../../layout/store/slice'
import { AUTHORIZATION_TYPE } from '../../../utils/authorization'
import { selectCompanyInfo } from '../../common/header/companyInfo/store/slice'
import useGetSettingFinancialStatement from '../common/useGetSettingFinancialStatement'
import { typeViewBy } from './constant'
import { getDetailPanel, getPanelDownload, renderComponent } from './helper'
import getActionDownload from './helper/actionDownloadHelpers'
import classes from './index.module.scss'
import { changePanelId, changeViewBy, selectDetailPanel } from './store/slice'

const Panel = ({ id }) => {
  const dispatch = useDispatch()

  const companyInfo = useSelector(selectCompanyInfo)
  const item = useSelector(selectDetailPanel(id))
  const userType = useSelector(selectUserType)
  const AUTHORIZATION_API = useSelector(selectComponentAuthorized)

  const { multiplier, currency, unitName } = useFormatCurrency(
    SCREEN.FINANCIAL_ANALYSIS,
  )

  const settings = useGetSettingFinancialStatement()

  if (!item) {
    return
  }

  const {
    height,
    viewByList: viewByListDetail,
    label,
    type,
  } = getDetailPanel(item.key)

  const chooseItem = (item) =>
    dispatch(changeViewBy({ id, viewBy: item.value }))

  const viewByList = viewByListDetail?.map((item) => ({
    label: <Translate value={`financialAnalysis.${item}`} />,
    value: item,
  }))

  const activeItem = { label: item.viewByActive, value: item.viewByActive }

  const panelId = `panel-${id}`

  const companyNameDownload =
    companyInfo?.organizationShortName ||
    companyInfo?.organizationName ||
    companyInfo?.taxCode

  const DownloadComponent = getPanelDownload(item.key, item.viewByActive, {
    viewBy: item.viewByActive,
    id: item.id,
  })

  const downloadParams = {
    downloadJpgParams: [typeViewBy.TREND, typeViewBy.EACH_YEAR].includes(
      item.viewByActive,
    )
      ? {
          DownloadComponent,
          domId: panelId,
          arrName: [I18n.t(label), companyNameDownload],
          titleJpg: I18n.t(label),
          source: I18n.t('common.SOURCE'),
          isFixSvg: DownloadComponent ? true : false,
        }
      : undefined,
    downloadCsv:
      item.viewByActive === typeViewBy.TABLE
        ? {
            downloadFunc: () =>
              getActionDownload(item.key)({
                organizationId: companyInfo.organizationId,
                sourceOrganizationId: companyInfo.organizationId,
                currency,
                currencyUnit: {
                  multiplier: multiplier,
                  value: unitName,
                  en_Value: unitName,
                },
                ...settings,
              }),
          }
        : undefined,
  }

  const isNotHasPermission =
    AUTHORIZATION_API.companyAnalysis.preferenceSettings[
      userType.userTypeId
    ] === AUTHORIZATION_TYPE.DISABLE

  return (
    <CommonPanel
      key={item.id}
      label={label}
      type={type}
      id={item.id}
      className={item.key}
      isAllowDragDrop={!isNotHasPermission}
      changeLayout={(data) =>
        dispatch(changePanelId(data.map((panel) => panel.id)))
      }
      height={type === panelTypes.HALF_SIZE ? 332 : height}
      isI18n
      isNotHasPermission={isNotHasPermission}
      renderRightHeader={
        viewByList &&
        (() => (
          <Element
            className={classes.viewByContainer}
            style={{ color: '#3A414B' }}
          >
            <Translate value="financialAnalysis.VIEW_BY" />
            <SelectCustom
              isBorderNone
              isI18n
              className="fw600"
              data={viewByList}
              activeItem={activeItem}
              chooseItem={chooseItem}
              scrollElementIds={['companyAnalysis']}
            />
          </Element>
        ))
      }
      {...downloadParams}
    >
      <Element id={panelId} className="h100 w100" style={{ color: '#3A414B' }}>
        {renderComponent(item.key, {
          viewBy: item.viewByActive,
          id: item.id,
        })()}
      </Element>
    </CommonPanel>
  )
}

Panel.propTypes = {
  id: PropTypes.string.isRequired,
}

export default Panel
